const reportWebVitals = (onPerfEntry?: (metric: { name: string, value: number }) => void) => {
  if (onPerfEntry && window.performance) {
    const metric = window.performance.getEntriesByType('measure')[0];
    if (metric) {
      onPerfEntry({
        name: metric.name,
        value: metric.duration,
      });
    }
  }
};

export default reportWebVitals;
